import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import 'ant-design-draggable-modal/dist/index.css';
import 'antd/dist/antd.css';
import '@smartlis/antd-theme/dist/antd.smartlis.css';
import './Custom.css';

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById('root')
);
